import { Component } from '@angular/core';

@Component({
    selector: 'ndt-two-column-layout',
    templateUrl: 'two-column-layout.component.html',
    host: {
        class: 'two-column-layout',
    },
    standalone: false
})
export class TwoColumnLayoutComponent {}
